import * as React from 'react';
import { DragHandlerProps } from './types';
import { useCallback } from 'react';
import { LngLat } from 'maplibre-gl';
import { useKineticMap } from 'components/maps';

const DragHandler: React.FunctionComponent<DragHandlerProps> = (props) => {
  const { children, onDrag, onDragEnd, onDragStart } = props;

  const map = useKineticMap();

  const mouseEventToLatLng = useCallback(
    (event: MouseEvent) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const { layerX, layerY } = event;
      return map.mapRef.current?.unproject([layerX, layerY]) ?? new LngLat(0, 0);
    },
    [map.mapRef]
  );

  return children({
    onContextMenu: (event: React.MouseEvent) => {
      event.preventDefault();
      onDragEnd(null, event);
      return false;
    },
    onMouseDown: (event: React.MouseEvent) => {
      event.preventDefault();
      // don't fire on right click.
      if (event.button === 2) {
        return;
      }
      map.setDragEnabled(false);
      const { lat: downLat, lng: downLng } = mouseEventToLatLng(event.nativeEvent);
      // TODO - fix this so that SVG elements don't 'hop' to origin when dragged
      onDragStart([downLng, downLat]);

      function handleMouseMove(moveEvent: MouseEvent) {
        const { lng: moveLng, lat: moveLat } = mouseEventToLatLng(moveEvent);
        onDrag([moveLng, moveLat]);
      }

      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', function handleMouseUp(mouseUpEvent: MouseEvent) {
        mouseUpEvent.preventDefault();

        map.setDragEnabled(true);
        document.removeEventListener('mouseup', handleMouseUp);
        document.removeEventListener('mousemove', handleMouseMove);
        const { lat: upLat, lng: upLng } = mouseEventToLatLng(mouseUpEvent);
        onDragEnd([upLng, upLat], mouseUpEvent);
      });
    },
  });
};

export default DragHandler;
